import { render, staticRenderFns } from "./platformSearch.vue?vue&type=template&id=59e1cc7e&"
import script from "./platformSearch.vue?vue&type=script&lang=js&"
export * from "./platformSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports